import React          from 'react'
import { Container }  from 'react-bootstrap'
import Typography     from 'entrada-ui/Typography'
import styles         from './styles.module.scss'

const PageTitle = ({ 
  title, 
  isDestination = false
}) => {
  return (
    // If compontent isDestination, wrap the title as "Awesome {Hobbiton} Tours"
    <>
      <div className={styles.spacer}></div>
      <Container className={styles.titleContainer}>
        <Typography variant='h1' className={styles.title}>
          { isDestination ? `Awesome ${title} Tours` : title }
        </Typography>
      </Container>
    </>
  )
}

export default PageTitle
